export const MMS_MAX_ATTACHMENT_COUNT = 10;
export const MMS_TOTAL_ATTACHMENT_SIZE_LIMIT = 4_500_000;

export const MMS_ACCEPTED_MIME_TYPES = new Set([
    'image/jpeg', 'image/jpg', 'image/gif', 'image/png',
    'image/heic', 'image/heif', 'image/tiff', 'image/bmp',
    'video/mpeg4', 'video/mp4', 'video/mpeg', 'video/webm',
    'video/quicktime', 'video/3gpp', 'video/3gpp2', 'video/3gpp-tt',
    'video/h261', 'video/h263', 'video/h263-1998', 'video/h263-2000',
    'video/h264', 'video/h265',
    'audio/ogg', 'audio/mpeg', 'audio/mp4', 'audio/mp3',
    'audio/3gpp', 'audio/3gpp2', 'audio/basic', 'audio/l24',
    'audio/vnd.rn-realaudio', 'audio/vnd.wave', 'audio/ac3',
    'audio/webm', 'audio/amr-nb', 'audio/amr',
    'text/vcard', 'text/x-vcard', 'text/directory',
    'text/csv', 'text/richtext', 'text/rtf', 'text/calendar',
    'application/pdf',
]);

const getTotalFileSize = (files: File[]) => files.reduce((total, file) => total + file.size, 0);

export const getSmsAttachmentsError = (files: File[]): string => {
    const unsupported = files.filter((f) => f.type !== '' && !MMS_ACCEPTED_MIME_TYPES.has(f.type));
    if (unsupported.length > 0) {
        const names = unsupported.map((f) => f.name).join(', ');
        return `Unsupported file type for MMS: ${names}. Please use images, audio, video, PDF, or vCard files.`;
    }

    if (files.length > MMS_MAX_ATTACHMENT_COUNT) {
        return `MMS supports at most ${MMS_MAX_ATTACHMENT_COUNT} attachments.`;
    }

    if (getTotalFileSize(files) > MMS_TOTAL_ATTACHMENT_SIZE_LIMIT) {
        return 'MMS attachments must be 4.5 MB or less in total.';
    }

    return '';
};
